var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    transform: "translate(0.539062 0.480469)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06838 7.44218L2.07088 4.01593C1.71713 3.6128 2.00463 2.97968 2.54151 2.97968H8.53651C8.65666 2.97957 8.7743 3.01411 8.87533 3.07914C8.97636 3.14417 9.0565 3.23695 9.10616 3.34636C9.15582 3.45577 9.17289 3.57717 9.15533 3.69604C9.13777 3.8149 9.08631 3.92618 9.00713 4.01655L6.00963 7.44155C5.95097 7.50868 5.87862 7.56249 5.79745 7.59935C5.71628 7.63622 5.62816 7.65529 5.53901 7.65529C5.44986 7.65529 5.36174 7.63622 5.28057 7.59935C5.19939 7.56249 5.12705 7.50868 5.06838 7.44155V7.44218Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.825f3942e4007a0024f8f6fec47733bf.svg";
export { ForwardRef as ReactComponent };